import {memo} from "react";
import {Button as ButtonMUI, ButtonProps as ButtonPropsMUI} from "@mui/material";
import clsx from "clsx";
import classes from './styles.module.scss';
export enum BtnType {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Outlined = 'Outlined',
  Text = 'Text',
  Raised = 'Raised',
  Danger = 'Danger'
}

interface ButtonProps extends ButtonPropsMUI {
  btnType?: BtnType;
  width?: string;
  padding?: string;
  nowrap?: boolean;
  className?: string;
  children?: React.ReactNode,
  sx?: any,
  type?: "button" | "submit" | "reset";
  isLoading?: boolean;
  onClick?: () => void;
  [key: string]: any; 
}

const Button = memo(function Button(props: ButtonProps) {
  const {
    width,
    padding,
    className,
    btnType,
    children,
    nowrap,
    type,
    onClick,
    sx = {},
    isLoading=false,
    ...rest
  } = props;
  return (
    <ButtonMUI
      loading={isLoading ?? false}
      className={clsx(
        "disabled:!opacity-70 disabled:!cursor-not-allowed",
        classes.root,
        classes.buttonComponent,
        {
          [classes.btnPrimary]: btnType === BtnType.Primary,
          [classes.btnSecondary]: btnType === BtnType.Secondary,
          [classes.btnOutlined]: btnType === BtnType.Outlined,
          [classes.btnText]: btnType === BtnType.Text,
          [classes.btnRaised]: btnType === BtnType.Raised,
          [classes.btnDanger]: btnType === BtnType.Danger,
        },
        className
      )}
      type={type as "button" | "submit" | "reset" ?? "button"}
      {...rest}
      sx={{...sx, minWidth: width, padding: padding, whiteSpace: nowrap ? "nowrap" : "unset"}}
      onClick={onClick}
    >
      {children}
    </ButtonMUI>
  );
});
export default Button;